const uzc = {
  search: "Search",
  update: "Update",
  delete: "Delete",
  created_at: "Data added at",
  save: "Save",
  choose: "Choose",
  view: "View",
  upload: "Upload",
  close: "Close",
  swal_sure:"Are you sure?",
  swal_delete:"You won't be able to revert this!",
  cancel: "Cancel",
  loadingText: "Loading",
  noDataText: "No data found!",
  new:"New",
  action:"Action",
  roles:"Roles",
  actions: "Actions",
  clear: "Clear",
  error_file: "The uploaded file did not fit into the template!",
  errorUniqueVin: "Change the VIN number!",
  error_file_title: "Error downloading!",
  file_input: "File Input",
  file: "File",
  example_file: "Example file",
  create_update_operation: "Successfully saved!",

  // ss
  realizedvin:{
    sent_data:"Sent data",
    vin: "Vehicle identification number(VIN)",
    add_vin: "Add Vehicle identification number",
    sdate:"Sales date",
    dealervin_name:"Distribution",
    date_required:"Date is required",
    vin_required:"Vin is required",
    included:"Date error included",
    error_written:"Error-not written in Latin",
    characters:"17 characters",
    update:"Update Vin",

  },
  uploadvin:{
    upload_vin:'Upload VIN',
    vin:'VIN',
    skd_plant:'Plant code',
    vin_gm:'Original VIN',
    vin_local:'New VIN',
    model_code:'Model code',
    model_year:'Model Year',
    engine:'Engine number',
    full_option:'Full Option',
    produced_date:'Produce date',
    to_dealer:'Dealer',
    sold_date:'Retail sales date',

  },
  settings:{
    settings:'Settings',
  },
  filesinfo:{
    files_info:'GWM files info',
    II001:'II001 files',
    II002:'II002 files',
  },
  dealers:{
    dealers:'Dealers',
    dealers_centers:'Organization name',
    name:'Distribution centers',
    bac:'Business access code to GWM (BAC)',
    country:'Country name',
    address:'Address',
    add_dealers:'Add distribution centers',
    characters:'6 characters',
    bac_required:'Business access code is required',
    update:'Update Dealer',
  },
  user: {
    user_list: "Users list",
    name: "Name",
    email: "E-mail",
    username: "Login",
    role: "Role",
    password_setting: "Password setting",
    add_user: "Add User",
    password: "Password",
    email_required: "E-mail is required",
    email_valid: "E-mail must be valid",
    email_unique: "Such an email exists!",
    required: "Required",
    min_char: "Min 8 characters",
    swal_txt: "DELETE USER",


  },
  permission: {
    index: "Resolution",
    name: "Permission name",
    display_name: "Show Name",
    description: "Description",
    dialogHeaderText: "Add new permissions",
    add: "Add new permissions",
    edit: "Edit",
    delete: "Are you sure you want to delete this permission?",
  },
  role: {
    index: "Roles",
    name: "Name role",
    display_name: "Display name",
    description: "Description",
    assigned_permissions: "Assigned permissions",
    not_assigned_permissions: "Unassigned permissions",
    dialogHeaderText: "Assign permissions to a role",
    add: "Add a new role",
  },
};

module.exports = uzc;